import { render, staticRenderFns } from "./chemicalStorage.vue?vue&type=template&id=04f1e959&scoped=true"
import script from "./chemicalStorage.vue?vue&type=script&lang=js"
export * from "./chemicalStorage.vue?vue&type=script&lang=js"
import style0 from "./chemicalStorage.vue?vue&type=style&index=0&id=04f1e959&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f1e959",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04f1e959')) {
      api.createRecord('04f1e959', component.options)
    } else {
      api.reload('04f1e959', component.options)
    }
    module.hot.accept("./chemicalStorage.vue?vue&type=template&id=04f1e959&scoped=true", function () {
      api.rerender('04f1e959', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chemicalStorage/chemicalStorage.vue"
export default component.exports